/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { LinearProgress } from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import { Button, ButtonToolbar, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import AppConfig from "../../../../config/AppConfig";

class BelumMengisi extends Component {
  // constructor(props, context) {
  //   super(props, context);
  // }
  state = {
    loadingList: true,
    param_3: "asc",
    listPtBelumMengisi: [],
  };

  changeOrder = () => {
    if (this.state.param_3 === "desc") {
      this.setState(
        {
          param_3: "asc",
        },
        () => {
          this.componentDidMount();
        }
      );
    } else {
      this.setState(
        {
          param_3: "desc",
        },
        () => {
          this.componentDidMount();
        }
      );
    }
  };

  componentDidMount() {
    this.setState({ loadingList: true });
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    // console.log(userdata);

    const url = window.location.pathname;
    var id = url.substring(url.lastIndexOf("/") + 1);

    var formData = new FormData();
    formData.append("data[param_3]", this.state.param_3);
    // console.log(this.state.param_3);
    axios
      .post(
        AppConfig.ListDetailRekapitulasi + id + "?id_bp=" + userdata.i_idbp,
        formData
      )
      .then((res) => {
        this.setState({
          loadingList: false,
          listPtBelumMengisi: res.data.result.pt_belum_isi,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  exportExcel = () => {
    let list_data = this.state.listPtBelumMengisi;
    var title =
      "<h3>Rekap Pelaporan SPMI Berdasarkan Perguruan Tinggi Yang Belum Mengisi</h3>";
    var tab_text =
      title +
      "<table border='2'><thead><tr><th>No</th><th>Perguruan Tinggi</th><th>Status</th></tr></thead><tbody>";
    var row = "";
    list_data.map((list, i) => {
      var no = i + 1;
      row += "<tr>";
      row += "<td align='center'>" + no + "</td>";
      row += "<td align='left'>" + list.nm_lemb + "</td>";
      row += "<td align='center'> - </td>";
      row += "</tr>";
    });

    tab_text = tab_text + row + "</tbody></table>";

    tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");
    tab_text = tab_text.replace(/<img[^>]*>/gi, "");
    tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, "");

    var link = window.document.createElement("a");

    link.setAttribute(
      "href",
      "data:text/xls;charset=utf-8,%EF%BB%BF" + encodeURIComponent(tab_text)
    );
    link.setAttribute("download", "rekap_pelaporan_spmi_pt_belum_mengisi.xls");
    link.click();
    return false;
  };

  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));

    let i = 0;
    let list_result = [];
    if (this.state.listPtBelumMengisi !== undefined) {
      for (var key in this.state.listPtBelumMengisi) {
        list_result[i] = {
          result: this.state.listPtBelumMengisi[key],
        };
        i++;
      }
    }

    return (
      <>
        {this.state.loadingList === false ? (
          <div className="row" style={{ marginBottom: "20px" }}>
            <div className="col-md-6">
              <div style={{ float: "left" }}>
                <ButtonToolbar>
                  <span className="svg-icon svg-icon-2x svg-icon-white">
                    <Button variant="success" onClick={this.exportExcel}>
                      <i
                        className="flaticon-download"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                      &nbsp; Export Excel
                    </Button>
                  </span>
                </ButtonToolbar>
              </div>
            </div>
            <div className="col-md-6">
              <div style={{ float: "right" }}>
                <ButtonToolbar>
                  <span className="svg-icon svg-icon-2x svg-icon-white">
                    <Link to="/rekapitulasi">
                      <Button variant="secondary">Kembali</Button>
                    </Link>
                  </span>
                </ButtonToolbar>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        <Table responsive hover style={{ overflow: "auto" }}>
          <thead className="text-white" style={{ backgroundColor: "#3047ad" }}>
            <tr>
              <th
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                No
              </th>
              <th
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                <i
                  className="flaticon2-sort"
                  style={{
                    marginRight: "10px",
                    color: "#ffffff",
                    fontSize: "14px",
                  }}
                  onClick={() => this.changeOrder()}
                ></i>
                Perguruan Tinggi
              </th>
            </tr>
          </thead>
          <tbody>
            {this.state.loadingList === true ? (
              <tr>
                <td colSpan="10">
                  <LinearProgress color="secondary" variant="query" />
                </td>
              </tr>
            ) : list_result.length > 0 ? (
              list_result.map((list, i) => (
                <tr>
                  <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                    {i + 1}
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    {list.result.nm_lemb}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: "center" }}>
                  <em>Data does not exist</em>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    );
  }
}
export default BelumMengisi;
